export interface Classifier {
  id: ClassifierType;
  title: string;
  valueName: string;
}

export type AdditionalAttributes = {
  hoursCount?: number;
  isAlternativeMedical?: boolean;
  isCompetencyHoursByGroup?: boolean;
  noClinicalHoursPercentage?: number;
  developmentHoursPercentage?: number;
  clinicalHoursPercentage?: number;
  targetedAudienceClassifiers?: string[];
  specialistLicenseTypes?: string[];
  parentGroup?: string;
  isServiceProvider?: string;
  generatedStampQualificationId?: string;
  restrictEventDuration?: boolean;
};

export interface ClassifierValue {
  id: string;
  type: string;
  groupName: string;
  valueName: string;
  comment: string;
  additionalAttributes?: AdditionalAttributes;
  dateFrom?: string;
  dateTo?: string;
  enabled: boolean;
  code?: string;
  isGeneratedStamp?: boolean;
  updatedAt?: string;
  createdAt?: string;
}

export interface FormClassifierValue
  extends Omit<ClassifierValue, "id" | "type" | "comment" | "enabled" | "groupName"> {
  groupName?: string;
}

export enum ClassifierType {
  // tobulinamų kompetencijų grupė
  DEVELOPMENT_COMPETENCY_GROUP = "DEVELOPMENT_COMPETENCY_GROUP",
  // Šalis
  COUNTRY = "COUNTRY",
  // Lietuvos miestai
  CITY = "CITY",
  // Įgyjamos ar tobulinamos kompetencijos
  TRAINING_PROGRAM = "TRAINING_PROGRAM",
  // C03.19 mokymo programos forma - Klasifikatorius
  PROGRAM_FORM = "PROGRAM_FORM",
  //C03.22 baigiamoji žinių ir gebėjimų įvertinimo forma - Klasifikatorius
  PROGRAM_EVALUATION_FORM = "PROGRAM_EVALUATION_FORM",
  //C03.23 privalomos temos
  MANDATORY_TOPIC = "MANDATORY_TOPIC",
  //C03.24 tikslinė programa, kurią atitinka
  TARGETED_PROGRAM = "TARGETED_PROGRAM",
  // "C03.3	tipas (profesinės kvalifikacijos tobulinimo programa, mokymų programa)"
  PROGRAM_TYPE = "PROGRAM_TYPE",
  // C03.31 programos vykdymo būdas - Klasifikatorius
  PROGRAM_METHOD_OF_EXECUTION = "PROGRAM_METHOD_OF_EXECUTION",
  // C12.4 išorinio vertintojo tipas klasifikatorius
  EXTERNAL_SPECIALIST_COMPETENCY_EVALUATION_TYPE = "EXTERNAL_SPECIALIST_COMPETENCY_EVALUATION_TYPE",
  // C03.10 Tikslinė klausytojų klasifikatorius
  // C07.5 Pareigybės, profesinės kvalifikacijos, specializacijos, kurioms skirtas profesinės kvalifikacijos tobulinimo renginys, klasifikatorius
  TARGETED_AUDIENCE = "TARGETED_AUDIENCE",
  // C14.3 Įstaigos teisinė forma
  INSTITUTION_LEGAL_FORM = "INSTITUTION_LEGAL_FORM",
  // C14.6 Įstaigos licencijos rūšis
  INSTITUTION_LICENSE_TYPE = "INSTITUTION_LICENSE_TYPE",
  // C14.9 Įstaigos licencijos būsena
  INSTITUTION_LICENSE_STATE = "INSTITUTION_LICENSE_STATE",
  // C03.38 Kompetencija
  PRACTICE_TYPE_SPECIALIZATION_COMPETENCY = "PRACTICE_TYPE_SPECIALIZATION_COMPETENCY",
  // C03.10 Tikslinė klausytojų grupė
  // C03.24 Vykdymo tipas
  PROGRAM_EXECUTION_TYPE = "PROGRAM_EXECUTION_TYPE",
  // C01.3-3 siauros medicinos praktikos kompetencija
  NARROW_MEDICAL_PRACTICE = "NARROW_MEDICAL_PRACTICE",
  PROGRAM_DECISION_REASON = "PROGRAM_DECISION_REASON",
  // C01.2-3 padalinys, kuriame dirbama, adresas
  INSTITUTION_WORK_ADDRESS = "INSTITUTION_WORK_ADDRESS",
  // C01.2-4 skyriaus, kuriame dirbama pavadinimas
  INSTITUTION_WORK_DEPARTMENT = "INSTITUTION_WORK_DEPARTMENT",
  // C01-15 profesinė kvalifikacija
  MEDICAL_PROFESSION_QUALIFICATION_TYPE = "MEDICAL_PROFESSION_QUALIFICATION_TYPE",
  //C01.2-6 pareigos
  INSTITUTION_WORK_OCCUPATION = "INSTITUTION_WORK_OCCUPATION",
  // C01-10 Licencijos tipas
  SPECIALIST_LICENSE_TYPE = "SPECIALIST_LICENSE_TYPE",
  // C07.6 renginio forma
  EVENT_FORM_TYPE = "EVENT_FORM_TYPE",
  /** Pažymėjimo neįskaitymo priežastis */
  CERTIFICATE_DECISION_REASON = "CERTIFICATE_DECISION_REASON",
  /** Kompetencijos neįskaitymo priežastis */
  COMPETENCY_DECISION_REASON = "COMPETENCY_DECISION_REASON",
  // C01.1-2 apdraustojo kategorija
  INSURED_PERSON_CATEGORY = "INSURED_PERSON_CATEGORY",
  // C01-13 nelicencijuojami visuomenės sveikatos priežiūros specialistai
  UNLICENSED_PUBLIC_HEALTHCARE_SPECIALISTS = "UNLICENSED_PUBLIC_HEALTHCARE_SPECIALISTS",
  // C01-16 veiklos rūšis
  HEALTH_ACTIVITY_TYPE = "HEALTH_ACTIVITY_TYPE",
  // C01-19 Siauros praktikos medicinos rūšis
  NARROW_HEALTH_PRACTICE_TYPE = "NARROW_HEALTH_PRACTICE_TYPE",
  // C01-20 specializacijos (slaugos, alternatyvios medicinos ir kt.)
  ALTERNATIVE_MEDICAL_SPECIALIST = "ALTERNATIVE_MEDICAL_SPECIALIST",
  // C01-5 spaudo numerio rūšis
  STAMP_NUMBER_TYPE = "STAMP_NUMBER_TYPE",
  // C09.2 Tipas
  EVENT_TYPE = "EVENT_TYPE",

  OTHER_TARGETED_AUDIENCE = "OTHER_TARGETED_AUDIENCE",
  INSTITUTION_HEALTHCARE_SERVICE = "INSTITUTION_HEALTHCARE_SERVICE",
}
